export const FETCH_PRACTICES_REQUEST = "FETCH_PRACTICES_REQUEST";
export const CREATE_PRACTICE_REQUEST = "CREATE_PRACTICE_REQUEST";
export const CHANGE_PRACTICE_STATUS_REQUEST = "CHANGE_PRACTICE_STATUS_REQUEST";
export const CHANGE_PRACTICE_WEIGHT_REQUEST = "CHANGE_PRACTICE_WEIGHT_REQUEST";
export const UPDATE_PRACTICE_REQUEST = "UPDATE_PRACTICE_REQUEST";
